import axios from "axios";
import * as URLS from "./utils/urls";
import { setAuthHeader } from "./utils/utils";
import { AJAX_REQUEST_TIMEOUT } from "../app/config/settings";

const triggerExportConteos = async (token, adClientID) => {
  const config = {
    url: URLS.TRIGGER_EXPORT_CONTEOS(adClientID),
    method: "GET",
    headers: setAuthHeader(token),
    responseType: "blob",
    timeout: AJAX_REQUEST_TIMEOUT,
  };

  return axios(config);
};

const exportAPI = {
  triggerExportConteos,
};

export default exportAPI;
